import { connect } from 'react-redux';

import ERAPage from 'components/pages/admin/ERAPage';
import { getTasks, getActivities } from 'actions/thunks/activities';
import {
  selectTasks, selectActivities, selectTasksLoading, selectActivitiesLoading,
} from 'selectors/activitiesSelectors';
import { selectIsAdmin, selectIsLoggedIn } from 'selectors/authenticationSelectors';
import { getApplicants } from 'actions/thunks/applicants';
import { getYear } from 'actions/thunks/systemSettings';
import { getStatuses } from 'actions/thunks/statuses';
import { selectApplicants, selectApplicantsLoading } from 'selectors/applicantsSelectors';
import { selectYear } from 'selectors/systemSettingsSelectors';
import { selectEventDates } from 'selectors/eventDatesSelectors';
import { selectStatuses, selectStatusesLoading } from 'selectors/statusesSelectors';
import { selectTaskPreferences } from 'selectors/taskPreferencesSelectors';
import { getTaskPreferences } from 'actions/thunks/taskPreferences';
import { getEventDates } from 'actions/thunks/eventDates';

const mapStateToProps = state => ({
  isLoggedIn: selectIsLoggedIn(state),
  isAdmin: selectIsAdmin(state),
  tasks: selectTasks(state),
  tasksLoading: selectTasksLoading(state),
  activities: selectActivities(state),
  applicants: selectApplicants(state),
  applicantsLoading: selectApplicantsLoading(state),
  year: selectYear(state),
  statuses: selectStatuses(state),
  activitiesLoading: selectActivitiesLoading(state),
  statusesLoading: selectStatusesLoading(state),
  eventDates: selectEventDates(state),
  taskPreferences: selectTaskPreferences(state),
});

const mapDispatchToProps = dispatch => ({
  getTaskPreferences: () => dispatch(getTaskPreferences()),
  getTasks: () => dispatch(getTasks()),
  getActivities: () => dispatch(getActivities()),
  getApplicants: () => dispatch(getApplicants()),
  getYear: () => dispatch(getYear()),
  getStatuses: () => dispatch(getStatuses()),
  getEventDates: () => dispatch(getEventDates()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ERAPage);
